export const user = state => state.auth.user
